module.exports = __webpack_public_path__ + "static/scale-model-of-greensboro-science-center-in-greensboro-north-carolina-ef43746a8d779208a00fc1d46b7aae46.png";